import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const MindmapViewOptionsRecord = Record({
  mindmapId: null,
  zoom: 1
});

createFromJS.registerCallback(
  "MindmapViewOptionsRecord",
  createFromJS.createPrimitiveCallback(MindmapViewOptionsRecord)
);
